//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class AddValueSetModel extends ModelBase {
      static readonly $typeName = 'AddValueSetModel';
      public name: string;
      public groupName: string;
      public codeSystemVersionKey: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/AddValueSetModel.ts